module.exports = __webpack_public_path__ + "media/images/soar/user_experience_joao-07214425a6e122b81bd566c2afac75c4.png";